var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.isLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","color":"#005C9E"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }